import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { DebounceInput } from 'react-debounce-input';

// action creators
import { blockRep, repListFetch, searchRep, unblockRep } from '../../../actions/repActions';

// components
import IndexRow from './_IndexRow';
import { Panel, PanelBody, PanelHeader } from '../../shared/_panel';

class Index extends React.Component {
    _handleRepSearch = (event) => {
      const { repSearch } = this.props;
      const repQuery = event.target.value;

      if (repQuery.length === 0) {
        this._initReps();
      } else if (repQuery.length > 2) {
        repSearch(repQuery);
      }
    };

    _initReps() {
      const { fetchReps } = this.props;

      fetchReps();
    }

    _renderReps() {
      const { rep } = this.props;
      const reps = rep.get('data') || Immutable.Map();
      const results = rep.get('result') || Immutable.List();
      const elements = [];

      results.forEach((repId) => {
        const r = reps.get(repId) || Immutable.Map();

        elements.push(
          <IndexRow key={ r.get('id') } onRepBlock={ this._handleBlockRep } onRepUnblock={ this._handleUnblockRep } rep={ r } />
        );
      });

      return elements;
    }

    _handleBlockRep = (id) => () => {
      const { repBlock } = this.props;

      repBlock(id);
    };

    _handleUnblockRep = (id) => () => {
      const { repUnblock } = this.props;

      repUnblock(id);
    };

    componentWillMount() {
      this._initReps();
    }

    render() {
      const { loading } = this.props;
      const listItems = this._renderReps();

      return (
        <Panel className='manager-reps__panel'>
          <PanelHeader className={ 'panel__header--manager-reps-list' }>
            <span>Reps</span>
            <div className='manager-reps__search-bar' style={ { opacity: loading ? 0 : 1 } }>
              <DebounceInput className='manager-reps__search-box'
                debounceTimeout={ 500 }
                disabled={ loading }
                onChange={ this._handleRepSearch }
                placeholder={ 'Search by name or product' } />
              <i aria-hidden='true' className='fa fa-search manager-reps__search-icon' />
            </div>
          </PanelHeader>
          <PanelBody>
            <div className='manager-reps-table'>
              <div className='manager-reps-table__header'>
                <div className='manager-reps-table__row--name'>Rep Name</div>
                <div className='manager-reps-table__row--company'>Company</div>
                <div className='manager-reps-table__row--products'>Products</div>
                <div className='manager-reps-table__row--phone'>Phone</div>
                <div className='manager-reps-table__row--email'>Email</div>
                <div className='manager-reps-table__row--button' />
              </div>
              <div className='manager-reps-table__body'>{loading ? <div className='manager-reps-table__loading'>Loading...</div> : listItems }</div>
            </div>
          </PanelBody>
        </Panel>
      );
    }
}

Index.propTypes = {
  fetchReps: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  rep: PropTypes.instanceOf(Immutable.Map),
  repBlock: PropTypes.func.isRequired,
  repSearch: PropTypes.func.isRequired,
  repUnblock: PropTypes.func.isRequired

};

const mapStateToProps = (state) => {
  return {
    rep: state.get('rep'),
    loading: state.getIn(['rep', 'loading'], true)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReps: () => {
      dispatch(repListFetch());
    },
    repSearch: (query) => dispatch(searchRep(query)),
    repBlock: (id) => dispatch(blockRep(id)),
    repUnblock: (id) => dispatch(unblockRep(id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./app/components/managers/reps/Index.jsx